import { render, staticRenderFns } from "./banSomeIp.vue?vue&type=template&id=e036ac06&"
import script from "./banSomeIp.vue?vue&type=script&lang=js&"
export * from "./banSomeIp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xc01/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e036ac06')) {
      api.createRecord('e036ac06', component.options)
    } else {
      api.reload('e036ac06', component.options)
    }
    module.hot.accept("./banSomeIp.vue?vue&type=template&id=e036ac06&", function () {
      api.rerender('e036ac06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/components/banSomeIp.vue"
export default component.exports